<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="lcStatus" @change="getLeaderboardCampaignList(true)" :disabled="loading" size="sm")
            option(:value="null") {{ $t('ui.all') }}
            option(:value="true") {{ $t('ui.active') }}
            option(:value="false") {{ $t('ui.inactive') }}
      .form-group.col-md-6.col-8.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLeaderboardCampaignList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isEditAccess")
        b-button(type="button" variant="info" size="sm" v-b-modal.addLeaderboard)
          i.fa.fa-lg.fa-plus
          span.ml-1 {{ $t("ui.combine.add_leaderboard") }}
      .form-group.col-12
        .alert.alert-warning.p-1 {{ $t("message.tooltips_leaderboard_campaign") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="17%" @click="sortOrder('leaderboard_campaign_name')")
                  span(:title="$t('ui.name')") {{ $t('ui.name') }}
                  .float-right
                    i(:class="changeSortKey('leaderboard_campaign_name')")
                th(width="8%" @click="sortOrder('criteria')")
                  span(:title="$t('ui.criteria')") {{ $t("ui.criteria") }}
                  .float-right
                    i(:class="changeSortKey('criteria')")
                th(width="8%")
                  span(:title="$t('ui.reward')") {{ $t("ui.reward") }}
                th.text-right(width="8%")
                  span.d-block(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                  span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                th.text-center(width="6%" @click="sortOrder('status')")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                  .float-right
                    i(:class="changeSortKey('status')")
                th.text-right(width="14%")
                  span(:title="$t('ui.settlement_date')") {{ $t("ui.settlement_date") }}
                th.text-right(width="14%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  .float-right
                    i(:class="changeSortKey('created_date')")
                th.text-right(width="14%")
                  span(:title="$t('ui.modified_date')") {{ $t('ui.modified_date') }}
                th.text-center(width="9%")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
            tbody.clusterize-content
              tr(v-if="leaderboardCampaignList.length == 0")
                td(colspan="14").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in leaderboardCampaignList")
                tr
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.leaderboard_campaign_name") {{ item.leaderboard_campaign_name }}
                    .float-right
                      i.fa.fa-lg(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  td.small
                    span.d-block(:title="item.criteria") {{ item.criteria }}
                    span(:title="$t('ui.capacity')") {{ item.capacity }}
                  td.small
                    span.d-block(:title="item.reward_type") {{ item.reward_type }}
                    span(:title="$t('ui.count')") {{ item.reward_count }}
                  td.text-right
                    span.d-block(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                    span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format('YYYY-MM-DD') }}
                  td
                    div.d-flex.justify-content-center.align-items-center
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                        span.custom-switch-indicator
                  td.text-right
                    span.d-block
                      i(:title='$t("ui.is_settled")' :class="{'fas fa-check text-info': item.is_settled, 'fas fa-times text-warning': !item.is_settled  }")
                    template(v-if="item.settlement_date")
                      span(:title="$moment(item.settlement_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.settlement_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    template(v-else)
                      span -
                  td.text-right
                    span(:title="item.created_by") {{ item.created_by }}
                    br
                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                  td.text-right
                    template(v-if="item.modified_date")
                      span(:title="item.modified_by") {{ item.modified_by }}
                      br
                      span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    template(v-else)
                      span -
                  td.text-center
                    template(v-if="isEditAccess")
                      span.mr-1(v-if="$moment(item.end_date).isSameOrAfter($moment(), 'day')")
                        a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEditLeaderboard(item)" :title="$t('ui.edit')")
                      span.mr-1(v-if="$moment(item.start_date) > $moment(new Date)")
                        a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="confirmDeleteLeaderboard(item)" :title="$t('ui.delete')")
                    span
                      a.fas.fa-crown.btn.btn-ssm.btn-icon.btn-warning(href="javascript:void(0)" @click="onOpenLeaderboardRanking(item)" :title="$t('ui.ranking')")

                tr(v-if="isShowDetail == true && currId == item.id")
                  td(colspan="15")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th(width="75%")
                            span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                          th.text-center(width="25%")
                            template(v-if="item.reward_type != 'PRIZE'")
                              span(:title="$t('ui.cash')") {{ $t('ui.cash') }}
                            template(v-else)
                              span(:title="$t('ui.prize')") {{ $t('ui.prize') }}
                      tbody.clusterize-content
                        tr
                          td
                            template(v-if="item.provider_list")
                              a.float-right.pointer(v-if="item.provider_list.split(',').map(p => p.trim()).length > 5" @click="showPAll = !showPAll")
                                i.fa(:class="showPAll ? 'fa-minus' : 'fa-plus'")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in (showPAll ? item.provider_list.split(',').map(p => p.trim()) : item.provider_list.split(',').map(p => p.trim()).slice(0, 5))"
                                :key="provider"
                                variant="secondary"
                              )
                                | {{ provider }}
                            template(v-else)
                              b-badge {{ $t('ui.all') }}
                          td.small
                            template(v-if="item.reward_count")
                              table.table.table-sm.mb-0
                                tbody
                                  tr.thead-light
                                    template(v-for="(x, idx) in Number(item.reward_count)")
                                      th.text-center {{ getOrdinal(idx + 1) }}
                                  tr
                                    template(v-for="(x, idx) in Number(item.reward_count)")
                                      template(v-if="item.reward_type != 'PRIZE'")
                                        td.text-center(v-if="item['cash_' + x] != null")
                                          span.font-weight-bold(:class="$helpers.fontClassName(item['cash_' + x])" :title="$n(item['cash_' + x], 'currency')") {{ $n(item['cash_' + x], 'currency') }}
                                        td.text-center(v-else)
                                          span -
                                      template(v-else)
                                        td.text-center(v-if="item['prize_' + x] != null")
                                          span(:title="item['prize_' + x]") {{ item['prize_' + x] }}
                                        td.text-center(v-else)
                                          span -
                            template(v-else)
                              span -

    addleaderboard(@clicked="addLeaderboard" @failed="handleFailed")
    editleaderboard(ref="editleaderboard" :lbId="selectedLeaderboardId"  @clicked="afterEditLeaderboard" @failed="handleFailed")
    leaderboardranking(ref="leaderboardranking" :item="selectedLeaderboard" :operatorID="operatorID")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addleaderboard from "@/components/leaderboard/addLeaderboard.vue";
import editleaderboard from "@/components/leaderboard/editLeaderboard.vue";
import leaderboardranking from "@/components/leaderboard/leaderboardRanking.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addleaderboard,
    editleaderboard,
    leaderboardranking
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "",
    sortType: "",
    leaderboardCampaignList: [],
    currId: null,
    isShowDetail: false,
    lcStatus: true,
    selectedLeaderboardId: null,
    selectedLeaderboard: null,
    showPAll: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeLeaderboard;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_leaderboard");
    }
  },
  mounted: function() {},
  methods: {
    refresh() {
      this.getLeaderboardCampaignList(true);
    },
    getOrdinal(n) {
      const s = ["th", "st", "nd", "rd"],
            v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    onOffDetail(item) {
      this.showPAll = false
      if (this.isShowDetail == true) {
        if (this.currId == item.id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.id;
      }
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLeaderboardCampaignList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onOpenLeaderboardRanking(e) {
      this.selectedLeaderboard = e;
      this.$refs.leaderboardranking.$refs.leaderboardRanking.show();
    },
    onEditLeaderboard(e) {
      this.selectedLeaderboardId = e.id;
      this.$refs.editleaderboard.$refs.editLeaderboard.show();
    },
    afterEditLeaderboard: function() {
      this.getLeaderboardCampaignList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_leaderboard"), this.$t("message.success"), "success");
    },
    addLeaderboard: function() {
      this.getLeaderboardCampaignList();
      this.$helpers.showDialog(this.$t("ui.combine.add_leaderboard"), this.$t("message.success"), "success");
    },
    getLeaderboardCampaignList: function(isSearch) {
      this.showPAll = false
      this.isShowDetail = false;
      this.currId = null;
      let url = config.leaderboardCampaignListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        leaderboard_campaign_status: this.lcStatus,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.leaderboardCampaignList = response.data.dt;
                this.totalRow = this.leaderboardCampaignList.length > 0 ? this.leaderboardCampaignList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_leaderboard_status_confirm", { name: item.leaderboard_campaign_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.leaderboardCampaignStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        leaderboard_campaign_id: item.id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getLeaderboardCampaignList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getLeaderboardCampaignList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmDeleteLeaderboard: function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_leaderboard_confirm", { name: e.leaderboard_campaign_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.deleteLeaderboard(e);
          } else {
            this.getLeaderboardCampaignList();
          }
        });
    },
    deleteLeaderboard: function(e) {
      let url = config.leaderboardCampaignDeleteUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        leaderboard_campaign_id: e.id,
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getLeaderboardCampaignList(true);
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeLeaderboard", pageSize);
      this.currentPage = 1;
      this.getLeaderboardCampaignList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLeaderboardCampaignList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>